export function getSellerLeadsApi(path: string) {
  return `${import.meta.env.VUE_APP_SELLER_LEAD_MANAGEMENT_API_BASE_URL}${path}`;
}

export function getHomeOwnerWorldApi(path: string) {
  return `${import.meta.env.VUE_APP_HOME_OWNER_WORLD_API}${path}`;
}

export function getAccountManagementApi(path: string) {
  return `${import.meta.env.VUE_APP_ACCOUNT_MANAGEMENT_API_BASE_URL}${path}`;
}
